import { useEffect } from "react";
import "./Alert.css";

const Alert = ({ object }) => {
    useEffect(() => {
        if (object?.durata && object.onClose) {
        const timer = setTimeout(() => object.onClose(), object.durata);
        return () => clearTimeout(timer);
        }
    }, [object]);

    if (!object?.messaggio) return null;

    return (
        <div id="alert-cont">
        <div id="alert">
            {/* <i className="fa-solid fa-xmark" onClick={object.onClose}></i> */}
            <div>
            <i className="fa-solid fa-triangle-exclamation"></i>
            <h1>{object.titolo || "Attenzione"}</h1>
            </div>
            <div>{object.messaggio}</div>
        </div>
        </div>
    );
};

export default Alert;
